import { useState } from 'react'

import { Alert } from '../components/ui.tsx'
import { useAuth } from '../lib/auth.tsx'
import { useAction } from '../lib/hooks.ts'

export function LoginPage(): React.JSX.Element {
  const { login } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const { run, pending, error } = useAction(login)

  const submit = (event: React.FormEvent): void => {
    event.preventDefault()
    void run(email, password)
  }

  return (
    <div className="login">
      <form className="login__box" onSubmit={submit}>
        <h1 className="login__title">Senses</h1>
        <p className="login__subtitle">Trénink neurovizuálních a kognitivních schopností</p>

        {error && <Alert>{error}</Alert>}

        <label className="field">
          <span className="field__label">E-mail</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
            autoFocus
          />
        </label>

        <label className="field">
          <span className="field__label">Heslo</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        <button type="submit" className="btn btn--primary btn--block" disabled={pending}>
          {pending ? 'Přihlašuji…' : 'Přihlásit se'}
        </button>

        <p className="field__help" style={{ marginTop: '1.25rem', textAlign: 'center' }}>
          Přístupové údaje ti vytvoří tvůj trenér.
        </p>
      </form>
    </div>
  )
}
